export const isAbsoluteUrl = (url: string) => /^(?:[a-z+]+:)?\/\//i.test(url);
